var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9C1 13.4177 4.58141 17 9 17C13.4177 17 17 13.4177 17 9C17 4.58227 13.4177 1 9 1C4.58141 1 1 4.58227 1 9Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67725 9.00032C6.67725 10.2829 7.71701 11.3229 8.99983 11.3229C10.2824 11.3229 11.3224 10.2829 11.3224 9.00032C11.3224 7.71775 10.2824 6.67773 8.99983 6.67773C7.71701 6.67773 6.67725 7.71775 6.67725 9.00032Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/statusIcon.008bd5199c4f9095dde08f329b9dc9fe.svg";
export { ForwardRef as ReactComponent };